class TabDeepLinker {
    constructor(selector) {
        this.selector = selector;
        this.init();
    }

    async init() {
        const urlParams = new URLSearchParams(window.location.search);
        let tabValue = urlParams.get('tab') || window.location.hash.replace('#', '');

        if (!tabValue) {
            this.finish();
            return;
        }

        tabValue = tabValue.toLowerCase().trim();
        await customElements.whenDefined('x-tabs');

        const tabsElement = document.querySelector(this.selector);

        if (!tabsElement) {
            this.finish();
            return;
        }

        const buttons = tabsElement.querySelectorAll('.video-tabs__title');
        this.processTab(tabsElement, buttons, tabValue);
    }

    processTab(tabsElement, buttons, tabValue) {
        const cleanTabValue = tabValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const targetIndex = Array.from(buttons).findIndex((button) => {
            const handle = (button.getAttribute('data-handle') || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();

            return handle === cleanTabValue || handle.includes(cleanTabValue);
        });

        if (targetIndex !== -1) {
            tabsElement.selectedIndex = targetIndex;
        }

        requestAnimationFrame(() => this.finish());
    }

    finish() {
        document.documentElement.classList.remove('video-tabs-deeplink-pending');
    }
}

new TabDeepLinker('x-tabs.video-tabs');
